export enum AnimalWhereaboutsType {
  DIED = 'died',
  ADOPTED = 'adopted',
  BACK_WITH_OWNER = 'back_with_owner',
  PASSED_ON = 'passed_on',
  RAN_AWAY = 'ran_away',
  RELEASED_INTO_WILD = 'released_into_wild',
  ADOPTED_ON_TRIAL = 'adopted_on_trial',
  OUTDOOR_ANIMAL = 'outdoor_animal',
  FOSTER_HOME = 'foster_home',
  EUTHANASIA = 'euthanasia',
  FOUNDANIMAL_RETURN = 'foundanimal_return'
}